/**
 * 重写history方法，添加公共参数
 */

import env from '@/shared/utils/env';
import { History } from '@medlinker/fundamental';
import qs from 'qs';

const rewriteNaviFunc =
  (func: any) =>
  (...args: any) => {
    const { _opentype, channel, sess, source } = qs.parse(
      window.location.search.slice(1)
    );

    let _query: any = {};

    if (_opentype !== undefined) {
      _query._opentype = _opentype;
    }

    if (channel !== undefined) {
      _query.channel = channel;
    }

    if (env.isWechatMiniProgram) {
      if (sess !== undefined) {
        _query.sess = sess;
      }
      if (source !== undefined) {
        _query.source = source;
      }
    }

    if (typeof args[0] === 'string') {
      const arr = args[0].split('?');

      _query = {
        ..._query,
        ...qs.parse(arr[1] || ''),
      };

      return func(
        arr[0] + qs.stringify(_query, { addQueryPrefix: true }),
        args[1]
      );
    } else if (typeof args[0] === 'object') {
      const { search = '', pathname } = args[0];

      const pathnameArr = pathname.split('?');

      _query = {
        ..._query,
        ...qs.parse(pathnameArr[1] || ''),
        ...qs.parse(search.slice(search.startsWith('?') ? 1 : 0)),
      };

      return func({
        ...args[0],
        pathname: pathnameArr[0],
        search: qs.stringify(_query, { addQueryPrefix: true }),
      });
    }

    return func(...args);
  };

export default (history: History) => {
  history.push = rewriteNaviFunc(history.push);
  history.replace = rewriteNaviFunc(history.replace);
  history.createHref = rewriteNaviFunc(history.createHref);
};
